var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltipWrap"},[_c('tippy',{scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('div',{staticClass:"tooltipWrap-info"},[_vm._v(" ? ")])]},proxy:true}])},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }